(() => {
  const arabicMoney = (value) => new Intl.NumberFormat('ar-QA-u-nu-arab', {
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  const arabicWholeMoney = (value) => new Intl.NumberFormat('ar-QA-u-nu-arab', {
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(value);

  const moneyPattern = /(?:QAR|QR|ر\.ق)\s*([0-9][0-9,]*(?:\.[0-9]+)?)|([0-9][0-9,]*(?:\.[0-9]+)?)\s*(?:QAR|QR|ر\.ق)/g;

  const translateMoney = (text) => text.replace(moneyPattern, (match, prefixAmount, suffixAmount) => {
    const amountText = prefixAmount || suffixAmount;
    const normalizedAmount = amountText.includes('.')
      ? amountText.replace(/,/g, '')
      : /,\d{2}$/.test(amountText)
        ? amountText.replace(',', '.')
        : amountText.replace(/,/g, '');
    const amount = Number(normalizedAmount);
    if (!Number.isFinite(amount)) return match;

    const formatted = `${arabicMoney(amount)} ر.ق`;
    return match.trimStart().startsWith('QAR') || match.trimStart().startsWith('QR') || match.trimStart().startsWith('ر.')
      ? formatted
      : formatted;
  });

  const translateTextNode = (node) => {
    if (!node.nodeValue) return;
    moneyPattern.lastIndex = 0;
    if (!moneyPattern.test(node.nodeValue)) return;
    moneyPattern.lastIndex = 0;
    node.nodeValue = translateMoney(node.nodeValue);
  };

  const scan = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('[data-mshq-money-cents]') || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT)$/i.test(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateTextNode);
  };

  const formatMarkedMoney = (root) => {
    const elements = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('[data-mshq-money-cents]')) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll('[data-mshq-money-cents]'));

    elements.forEach((element) => {
      const cents = Number(element.dataset.mshqMoneyCents);
      if (!Number.isFinite(cents)) return;
      const amount = cents / 100;
      element.textContent = `${element.dataset.mshqMoneyFormat === 'whole' ? arabicWholeMoney(amount) : arabicMoney(amount)} ر.ق`;
    });
  };

  const start = () => {
    if (document.documentElement.lang !== 'ar') return;
    scan(document.body);
    formatMarkedMoney(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
          else if (node.nodeType === Node.ELEMENT_NODE) {
            scan(node);
            formatMarkedMoney(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
